module.exports = __webpack_public_path__ + "static/img/bg-login.0c97a773.jpg";